import { Component } from '@angular/core';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/database';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'cl-brain-plt';
}
